import React from "react";
import { apiCalonAlihkan, apiAlihkan, formatApiErrorDetail } from "@/lib/api";
import { X } from "lucide-react";

const inputCls = "rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-200";

// T2-A (owner 2026-10-08): the Owner moves work in progress to another active
// operator of the same station; reason required; the server checks everything.
// v2.21: a Desain step still waiting goes to another designer or is opened to every designer ("SEMUA").
export default function AlihkanPanel({ item, onDone, onClose }) {
  const menunggu = item.status === "PENDING" && !item.bagian_id;
  const [calon, setCalon] = React.useState(null);
  const [ke, setKe] = React.useState("");
  const [alasan, setAlasan] = React.useState("");
  const [error, setError] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  React.useEffect(() => {
    apiCalonAlihkan(item.spk_id, item.instance_id, item.urutan, item.bagian_id || null).then(setCalon)
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  }, [item]);
  const kirim = async () => {
    setBusy(true); setError(null);
    try { await apiAlihkan(item.spk_id, item.instance_id, item.urutan, { operator_id: ke, alasan, ...(item.bagian_id ? { bagian_id: item.bagian_id } : {}) }); onDone(); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };
  return (
    <div data-testid="alihkan-panel" className="rounded-xl border border-amber-500/40 bg-slate-900/80 p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-100">Alihkan pekerjaan — {item.nomor_spk} · {item.pos_nama || item.pos_code}{item.bagian_id ? ` · bagian ${item.bagian_pcs} pcs` : ""}</h3>
        {onClose && <button onClick={onClose} className="text-slate-400"><X size={16} /></button>}
      </div>
      {menunggu
        ? <p data-testid="alihkan-menunggu" className="text-xs text-slate-400">Belum dimulai. Saat ini untuk <b className="text-slate-200">{item.desain_untuk?.nama || "semua desainer"}</b>; setelah dialihkan hanya desainer baru yang bisa menekan Mulai.</p>
        : <p className="text-xs text-slate-400">Sedang dikerjakan <b className="text-slate-200">{item.started_by_username || "—"}</b>. Pekerjaan tetap berstatus sedang diproses; operator baru menekan Selesai dan upahnya dihitung untuk yang menyelesaikan.</p>}
      {error && <p data-testid="alihkan-error" className="text-xs text-red-300">{error}</p>}
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-xs text-slate-400">Alihkan ke
          <select data-testid="alihkan-ke" value={ke} onChange={(e) => setKe(e.target.value)} className={`${inputCls} block`}>
            <option value="">— pilih operator aktif —</option>
            {menunggu && item.desain_untuk && <option value="SEMUA">Semua desainer (siapa saja boleh Mulai)</option>}
            {(calon || []).map((c) => <option key={c.id} value={c.id}>{c.nama || c.username} ({c.username})</option>)}
          </select></label>
        <label className="flex-1 min-w-[16rem] text-xs text-slate-400">Alasan (wajib)
          <input data-testid="alihkan-alasan" value={alasan} maxLength={300} onChange={(e) => setAlasan(e.target.value)} placeholder="contoh: operator tidak masuk kerja" className={`${inputCls} block w-full`} /></label>
        <button data-testid="alihkan-kirim" disabled={busy || !ke || alasan.trim().length < 5} onClick={kirim} className="rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 disabled:opacity-40">Alihkan</button>
      </div>
      {calon && calon.length === 0 && !(menunggu && item.desain_untuk) && <p className="text-xs text-amber-300">Tidak ada operator aktif lain di pos ini.</p>}
    </div>
  );
}
